import moment from 'moment';

/**
 * Generates a random date within the next six months, formatted as YYYY-MM-DD.
 *
 * This function works by calculating the timestamp range between today and six months
 * from now, generating a random timestamp within that range, and then creating a
 * formatted date string from it.
 *
 * @returns {string} The random date string in 'YYYY-MM-DD' format.
 */
export const getRandomFutureDate = ({
   months = 6
}) => {
   
   months = parseInt(months);
   
   if (isNaN(months) || months < 1) {
      months = 1;
   }
   
   // Get the current moment (today)
   const today = moment();
   
   // Get the moment 6 months from now
   const nextSixMonths = moment().add(months, 'months');
   
   // Get the milliseconds since epoch for both dates
   const startTimestamp = today.valueOf();
   const endTimestamp = nextSixMonths.valueOf();
   
   // Calculate a random timestamp between the start and end timestamps
   // Math.random() generates a number between 0 (inclusive) and 1 (exclusive)
   const randomTimestamp = startTimestamp + Math.random() * (endTimestamp - startTimestamp);
   
   // Convert the random timestamp back into a moment object and format it
   const randomDate = moment(randomTimestamp).format('YYYY-MM-DD');
   
   return randomDate;
};

// Example usage (optional, for testing):
// console.log("Generated Random Date:", getRandomDateNextSixMonths());